// startup
// Load entry module and return exports
__webpack_require__("./assets/js/scripts/additional-info.js");
__webpack_require__("./assets/js/scripts/nav.js");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./assets/css/style.scss");
